<div class="content">
  <router-outlet></router-outlet>
  <div class="footer" *ngIf="!isPluginPrivacyPolicy">
    <a *ngIf="currentRoute!='/'" routerLink="/">Plugins</a>
    <a *ngIf="currentRoute!='/faqs'" routerLink="/faqs">FAQs</a>
    <a *ngIf="currentRoute!='/privacy-policy'" routerLink="/privacy-policy">Privacy Policy</a>
  </div>
  <!-- <div class="night-mode-fab" [class.day]="isNightModeEnabled" [class.night]="!isNightModeEnabled" (click)="toggleNightMode()">{{isNightModeEnabled?'🌕':'🌙'}}</div> -->    
</div>